import React from "react";
import {
  Box,
  Container,
  SimpleGrid,
  Stack,
  Text,
  Flex,
  Icon,
  Link,
  useColorModeValue,
  Input,
  Button,
  VStack,
  HStack,
  Heading,
  Divider
} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import { FaHome, FaPhone, FaEnvelope, FaWhatsapp, FaLinkedin, FaTwitter, FaFacebook, FaInstagram } from "react-icons/fa";
import { useMediaQuery } from "react-responsive";
import config from '../../config';

function Footer() {
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1024px)" });
  const bgColor = useColorModeValue('gray.900', 'gray.900');
  const textColor = useColorModeValue('gray.400', 'gray.400');
  const headingColor = useColorModeValue('white', 'white');
  const hoverColor = useColorModeValue('blue.400', 'blue.400');

  const handleSubscribe = (e) => {
    e.preventDefault();
    // Add newsletter subscription logic here
  };

  return (
    <Box bg={bgColor} color={textColor}>
      {/* Top Contact Section */}
      <Box borderBottom="1px" borderColor="gray.700">
        <Container maxW="container.xl" py={8}>
          <SimpleGrid columns={{ base: 1, md: 3 }} spacing={8}>
            {/* Phone */}
            <Flex align="center" justify="center">
              <Icon as={FaPhone} w={8} h={8} color="blue.400" mr={4} />
              <Box>
                <Text fontWeight="bold" color={headingColor}>Call Us</Text>
                <Link href="tel:9473421755" color={textColor} _hover={{ color: hoverColor }}>
                  9473421755
                </Link>
              </Box>
            </Flex>

            {/* Email */}
            <Flex align="center" justify="center">
              <Icon as={FaEnvelope} w={8} h={8} color="blue.400" mr={4} />
              <Box>
                <Text fontWeight="bold" color={headingColor}>Email Us</Text>
                <Link href="mailto:partners@orivanta.ai" color={textColor} _hover={{ color: hoverColor }}>
                  partners@orivanta.ai
                </Link>
              </Box>
            </Flex>

            {/* WhatsApp */}
            <Flex align="center" justify="center">
              <Icon as={FaWhatsapp} w={8} h={8} color="blue.400" mr={4} />
              <Box>
                <Text fontWeight="bold" color={headingColor}>WhatsApp</Text>
                <Link href="https://wa.me/+919473421755" color={textColor} _hover={{ color: hoverColor }}>
                  9473421755
                </Link>
              </Box>
            </Flex>
          </SimpleGrid>
        </Container>
      </Box>

      {/* Main Footer Content with Left Home Icon - Navigates to Home */}
      <Container maxW="container.xl" py={6}>
        <Flex justify="flex-start" align="center" wrap="wrap">
          {/* Left Home Icon - now navigates to home */}
          <Box display={{ base: 'none', md: 'block' }} ml={{ md: -10 }} mr={{ md: 10 }}>
            <RouterLink to="/" onClick={() => {
              window.scrollTo(0, 0);
            }}>
              <Icon
                as={FaHome}
                w={8}
                h={8}
                color={headingColor}
                cursor="pointer"
                _hover={{ color: hoverColor }}
              />
            </RouterLink>
          </Box>

          {/* Main Footer Content Grid */}
          <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={10} flex="1" px={{ base: 0, md: 4 }}>
            {/* Company Info */}
            <Stack spacing={6}>
              <Heading size="md" color={headingColor}>About Us</Heading>
              <Text>
                {config.companyName} is a leading technology solutions provider, delivering innovative software development services to businesses worldwide.
              </Text>
              <HStack spacing={4}>
                <Link href="#" color={textColor} _hover={{ color: hoverColor }}>
                  <Icon as={FaLinkedin} w={6} h={6} />
                </Link>
                <Link href="#" color={textColor} _hover={{ color: hoverColor }}>
                  <Icon as={FaTwitter} w={6} h={6} />
                </Link>
                <Link href="#" color={textColor} _hover={{ color: hoverColor }}>
                  <Icon as={FaFacebook} w={6} h={6} />
                </Link>
                <Link href="#" color={textColor} _hover={{ color: hoverColor }}>
                  <Icon as={FaInstagram} w={6} h={6} />
                </Link>
              </HStack>
            </Stack>

            {/* Quick Links */}
            <Stack spacing={6}>
              <Heading size="md" color={headingColor}>Quick Links</Heading>
              <Stack direction="column" spacing={3}>
                <Link as={RouterLink} to="/" color={textColor} _hover={{ color: hoverColor }}>Home</Link>
                <Link as={RouterLink} to="/services" color={textColor} _hover={{ color: hoverColor }}>Services</Link>
                <Link as={RouterLink} to="/about" color={textColor} _hover={{ color: hoverColor }}>About Us</Link>
                <Link as={RouterLink} to="/contact" color={textColor} _hover={{ color: hoverColor }}>Contact</Link>
                <Link as={RouterLink} to="/career" color={textColor} _hover={{ color: hoverColor }}>Careers</Link>
              </Stack>
            </Stack>

            {/* Services */}
            <Stack spacing={6}>
              <Heading size="md" color={headingColor}>Our Services</Heading>
              <Stack direction="column" spacing={3}>
                <Link as={RouterLink} to="/services#web" color={textColor} _hover={{ color: hoverColor }}>Web Development</Link>
                <Link as={RouterLink} to="/services#app" color={textColor} _hover={{ color: hoverColor }}>App Development</Link>
                <Link as={RouterLink} to="/services#api" color={textColor} _hover={{ color: hoverColor }}>API Development</Link>
                <Link as={RouterLink} to="/services#ai" color={textColor} _hover={{ color: hoverColor }}>AI Solutions</Link>
                <Link as={RouterLink} to="/services#outsourcing" color={textColor} _hover={{ color: hoverColor }}>IT Outsourcing</Link>
              </Stack>
            </Stack>

            {/* Newsletter */}
            <Stack spacing={6}>
              <Heading size="md" color={headingColor}>Newsletter</Heading>
              <Text>Subscribe to our newsletter for the latest updates and insights.</Text>
              <form onSubmit={handleSubscribe}>
                <VStack spacing={3}>
                  <Input
                    placeholder="Enter your email"
                    bg="gray.700"
                    border={0}
                    _focus={{
                      bg: 'gray.600',
                      outline: 'none',
                      border: '1px solid',
                      borderColor: 'blue.400',
                    }}
                  />
                  <Button
                    type="submit"
                    bg="blue.400"
                    color="white"
                    _hover={{
                      bg: 'blue.500',
                    }}
                    w="full"
                  >
                    Subscribe
                  </Button>
                </VStack>
              </form>
            </Stack>
          </SimpleGrid>
        </Flex>
      </Container>

      {/* Bottom Footer */}
      <Box borderTop="1px" borderColor="gray.700">
        <Container maxW="container.xl" py={6}>
          <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
            {/* Copyright */}
            <Text textAlign={{ base: 'center', md: 'left' }}>
              © {new Date().getFullYear()} {config.companyName}. All rights reserved.
            </Text>

            {/* Legal Links */}
            <Stack
              direction={{ base: 'column', md: 'row' }}
              spacing={4}
              justify={{ base: 'center', md: 'flex-end' }}
            >
              <Link as={RouterLink} to="/terms" color={textColor} _hover={{ color: hoverColor }}>
                Terms & Conditions
              </Link>
              <Link as={RouterLink} to="/privacy" color={textColor} _hover={{ color: hoverColor }}>
                Privacy Policy
              </Link>
              <Link as={RouterLink} to="/sitemap" color={textColor} _hover={{ color: hoverColor }}>
                Sitemap
              </Link>
            </Stack>
          </SimpleGrid>
        </Container>
      </Box>
    </Box>
  );
}

export default Footer;
